var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "generic-modal-wrap",
    { attrs: { "modal-id": "MoreAboutPrioritySupport" } },
    [
      _c("h2", { staticClass: "nodal-title" }, [
        _vm._v("\n\t\tPriority Support\n\t"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ratio ratio-16x9 mb-2" }, [
        _c("iframe", {
          attrs: {
            src: "//www.youtube.com/embed/ZRvA2Ah1y14?autoplay=1&rel=0",
            frameborder: "0",
            allowfullscreen: "",
          },
        }),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v(
          "\n\t\tIf the video doesn't appear, click this link to watch it on Youtube:"
        ),
        _c("br"),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "//www.youtube.com/watch/ZRvA2Ah1y14",
              target: "_blank",
              rel: "noopener noreferrer",
            },
          },
          [_vm._v("http://www.youtube.com/watch?v=ZRvA2Ah1y14")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }